import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mainPlayerToggle } from "../../redux/actions/styles";
import MusicPlayer from "./MusicPlayer";
import TopArtists from "./TopArtists";
import TopSongs from "./TopSongs";
import Trending from "./Trending";

const Explore = (props) => {
  const dispatch = useDispatch();
  const musicPlayerRef = useRef(null);

  const { playSong, pauseSong, onChangeRange, toggleVolume, onClickPrev, onClickNext } = props;

  const { play } = useSelector((state) => state.player);

  useEffect(() => {
    dispatch(mainPlayerToggle(false));

    return () => {
      play && dispatch(mainPlayerToggle(true));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play]);

  return (
    <div className="explore">
      <Trending musicPlayerRef={musicPlayerRef} />
      <div className="card-layout">
        <TopArtists />
        <MusicPlayer
          playSong={playSong}
          pauseSong={pauseSong}
          onChangeRange={onChangeRange}
          toggleVolume={toggleVolume}
          musicPlayerRef={musicPlayerRef}
          onClickPrev={onClickPrev}
          onClickNext={onClickNext}
        />
        <TopSongs />
      </div>
    </div>
  );
};

export default Explore;
